import { HydratedRouter } from "react-router/dom";
import { startTransition } from "react";
import { hydrateRoot } from "react-dom/client";

startTransition(() => {
  hydrateRoot(
    document,
    <HydratedRouter />
  );
});

// Initialize Sentry AFTER hydration (production only)
if (typeof window !== 'undefined') {
  const env = (window as any).ENV;

  if (env?.SENTRY_DSN) {
    import("@sentry/react").then(({ init }) => {
      init({
        dsn: env.SENTRY_DSN,
        environment: env.APP_ENV || 'development',
        tracesSampleRate: 1,
      });
    });
  }
}
